const shadows = {
  xs: '0 0 0 1px rgba(18, 92, 83, 0.05)',
  sm: '0 1px 2px 0 rgba(18, 92, 83, 0.05)',
  base: '0 1px 3px 0 rgba(18, 92, 83, 0.1), 0 1px 2px 0 rgba(18, 92, 83, 0.06)',
  md: '0 4px 6px -1px rgba(18, 92, 83, 0.1), 0 2px 4px -1px rgba(18, 92, 83, 0.06)',
  'reverse-md':
    '0 -4px 6px -1px rgba(18, 92, 83, 0.1), 0 -2px 4px -1px rgba(18, 92, 83, 0.06)',
  lg: '0 10px 15px -3px rgba(18, 92, 83, 0.1), 0 4px 6px -2px rgba(18, 92, 83, 0.05)',
  xl: '0 16px 40px rgba(18, 92, 83, 0.15);',
  '2xl': '0 25px 50px -12px rgba(18, 92, 83, 0.25)',
  outline: '0 0 0 3px rgba(66, 153, 225, 0.6)',
  inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
  none: 'none',
  'dark-lg':
    'rgba(18, 92, 83, 0.1) 0px 0px 0px 1px, rgba(18, 92, 83, 0.2) 0px 5px 10px, rgba(18, 92, 83, 0.4) 0px 15px 40px',
}

export default shadows
